import { TransactionMode } from 'app/types/listing';

type MarketValue = { kind: 'estimated'; value: number } | null;

export function getOfferMarketValue({
  estimatedPrice,
  marketValueEnabled,
  transactionMode,
}: {
  estimatedPrice?: number | null;
  marketValueEnabled: boolean;
  transactionMode?: TransactionMode | null;
}): MarketValue {
  const mode = transactionMode ?? TransactionMode.lend;
  if (mode === TransactionMode.sell) return null;

  if (marketValueEnabled && estimatedPrice !== null && estimatedPrice !== undefined) {
    return { kind: 'estimated', value: estimatedPrice };
  }

  return null;
}
